import { FormioOptions, FormioRefreshValue } from '@formio/angular';
import { Component, AfterViewInit, ViewChild, ElementRef, EventEmitter, ViewEncapsulation, OnInit, ChangeDetectorRef } from '@angular/core';
import { PrismService } from '../Prism.service';
import { Subject, firstValueFrom } from 'rxjs';
import { options } from './options';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../data.service';
import { Router } from '@angular/router';
import bootstrap4 from '@formio/bootstrap/bootstrap4';
import { Formio } from '@formio/js';
Formio.use(bootstrap4);
import { ColumnMode, SelectionType, SortType } from '@swimlane/ngx-datatable';
import { jsPDF } from "jspdf";
import html2pdf from 'html2pdf.js';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import { IonModal } from '@ionic/angular';
import { AuthService } from '../auth.service';

/*  A FORMIO SAJÁT KÉRÉSEI IS VIGYÉK A JEGYET.
 *
 *  A kérvénysablonok legördülői (pl. a „gyermek" mező) a Formio saját `fetch`-ével
 *  töltik a listát a mi `/api` címünkről – ez az Angular interceptort megkerüli, tehát
 *  token nélkül ment ki. 2026-09-23 óta a családi végpontok token nélkül nem adnak
 *  adatot, így a szülőnek üres maradt a gyermek-választó (Zenit, hibajegy #1083).
 *  A bővítmény csak a saját `/api` címekre teszi rá a jegyet, idegen címre soha. */
let formioJegy: () => string | null = () => null;
Formio.registerPlugin({
  priority: 0,
  requestOptions: (opts: any, url: string) => {
    try {
      const cim = String(url || '');
      const sajat = cim.startsWith('/api/') || cim.startsWith(`${window.location.origin}/api/`);
      const jegy = sajat ? formioJegy() : null;
      if (jegy) {
        opts.headers = opts.headers || new Headers();
        if (typeof opts.headers.set === 'function') opts.headers.set('Authorization', 'Bearer ' + jegy);
        else opts.headers['Authorization'] = 'Bearer ' + jegy;
      }
    } catch { /* a kérés jegy nélkül megy tovább */ }
    return opts;
  },
}, 'sulinformJegy');

@Component({
  selector: 'app-urlap',
  templateUrl: './urlap.component.html',
  styleUrls: ['./urlap.component.scss'],
  //encapsulation: ViewEncapsulation.ShadowDom,
})
export class UrlapComponent implements AfterViewInit, OnInit {


  protected readonly ColumnMode = ColumnMode;
  protected readonly SortType = SortType;
  protected readonly JSON = JSON;
  protected readonly moment = moment;


  @ViewChild('json', { static: true }) jsonElement?: ElementRef;
  @ViewChild('code', { static: true }) codeElement?: ElementRef;
  form;
  forms = []
  csakkerveny = []
  /** A „Kérvény kitöltése" listán megjelenő sorok: se dokumentum-sablon, se lejárt kérvény. */
  kitolthetoKervenyek = []
  formseredeti = []
  csakhatarozat = []
  public options: any;
  public language: string;
  public refreshForm: EventEmitter<FormioRefreshValue> = new EventEmitter();
  public rebuildEmitter: Subject<object> = new Subject<object>();
  constructor(private ref:ChangeDetectorRef,private http: HttpClient/*,public prism: PrismService*/, private data: DataService, private router: Router, private auth: AuthService) {
    formioJegy = () => (this.auth.isStandaloneLogin() ? this.auth.getLocalToken() : this.auth.accessToken) || null;
    this.options = options
    this.form = { components: [], display: 'form' };
    setTimeout(() => {
      this.rebuildEmitter.next(this.options);
    }, 1000);

  }

  @ViewChild("dontesmodal") dontesmodal: IonModal;
  @ViewChild("atadasmodal") atadasmodal: IonModal;

  menu = 1
  urlmatrix = [
    {}, { url: "adatszolg" }, { url: "szamla" }, { url: "beszerzes" }, { url: "statisztika" }, { url: "egyenleg" }
  ]

  sajatIntezmeny
  htmlContent: string = '';
  egyenleg = -1
  loginmode
  selectedForm: any
  selectedHatarozat
  openedformid
  betoltott = true;
  formReadOnly = false;
  sajatforms = []
  user$
  userMetadata
  allforms = []

  // ─────────────────────────── Kérvény-szűrőpanel ───────────────────────────
  // Kliens-oldali, élő szűrés a beküldött kérvények listáin (menü 4: sajátok, menü 6:
  // közös feladatkosár). Ugyanaz a panel jelenik meg mindkét nézetben; a statisztika a
  // pillanatnyilag látható listára vonatkozik.
  showKFilters = false;
  kfilter = {
    search: '',
    dateFrom: '',
    dateTo: '',
    status: { '1': false, '2': false, '21': false, '4': false, '3': false } as { [k: string]: boolean },
    kerveny: '',
  };
  kStatusDefs = [
    { k: '1', nev: 'Ügyintézés szükséges', dot: 'blue' },
    { k: '2', nev: 'Elfogadva', dot: 'green' },
    { k: '21', nev: 'Határozattal elfogadva', dot: 'green' },
    { k: '4', nev: 'Hiánypótlás szükséges', dot: 'orange' },
    { k: '3', nev: 'Elutasítva', dot: 'red' },
  ];
  kervenyLista: { id: any; name: string }[] = [];
  filteredSajatforms = [];
  filteredAllforms = [];
  pdfMeretek = [
    { value: 'a4', label: 'A4' },
    { value: 'a3', label: 'A3' },
    { value: 'a5', label: 'A5' },
    { value: 'letter', label: 'Letter' },
    { value: 'legal', label: 'Legal' },
    { value: 'custom', label: 'Egyedi méret' },
  ]
  pdfFekvesek = [
    { value: 'portrait', label: 'Álló' },
    { value: 'landscape', label: 'Fekvő' },
  ]


  /**
   *  A kérvény-modul belső menüje jogosultság szerint (Jogosultságok szerkesztő,
   *  „Kérvények – belső nézetek"). Alapból mindent enged, amíg a jogosultság megjön,
   *  hogy a menü ne villanjon el a betöltés alatt.
   */
  private kervenyJog: { mind: boolean; szabad: (url: string) => boolean } = { mind: true, szabad: () => true };

  lathatoKerveny(pont: string): boolean {
    return this.kervenyJog.szabad('/kerveny/' + pont);
  }

  async ngOnInit() {
    this.kervenyJog = await this.data.hozzaferesek();
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))
    this.egyenleg = (await this.data.getFromStorage("egyenleg"))
    this.loginmode = (await this.data.getFromStorage("loginmode"))
    this.user$ = await this.data.getFromStorage("user")
    this.userMetadata = await this.data.getFromStorage("userMetadata")
    //window.location.replace("/admin/importallomany")
    //this.import=4
    //this.menuChange(4)
    //if(window.location.pathname.indexOf("admin/import") != -1)

    console.log(this.user$)
  }

  getRowClass = (row) => {
    return {
      'row-color-blue': row.status == 1,
      'row-color-green': row.status == 2 || row.status == 21,
      'row-color-red': row.status == 3
    };
  }

  openComponent(c) {

  }

  /**
   * Lejárt-e a kérvény? Üres / értelmezhetetlen / 0000-00-00 érvényességi vég = nincs lejárat.
   * A mai nap még érvényes (a lejárat napján is kitölthető).
   */
  private lejart(sablon: any): boolean {
    const vege = sablon?.erv_vege;
    if (!vege || String(vege).startsWith('0000')) return false;
    const v = moment(vege);
    if (!v.isValid()) return false;
    return v.endOf('day').isBefore(moment());
  }

  // A kérvény-típus lenyíló lehetőségei az adatból (előforduló kérvények id → név).
  buildKervenyFacets() {
    const m = new Map<string, string>();
    [...(this.allforms || []), ...(this.sajatforms || [])].forEach((r: any) => {
      if (r?.kervenyid != null) {
        const nev = r?.data?.name
          || (this.csakkerveny.find((k: any) => k.id == r.kervenyid) as any)?.name
          || ('#' + r.kervenyid);
        m.set(String(r.kervenyid), nev);
      }
    });
    this.kervenyLista = Array.from(m, ([id, name]) => ({ id, name }))
      .sort((a, b) => String(a.name).localeCompare(String(b.name), 'hu'));
  }

  // Egy lista szűrése az aktuális kfilter szerint.
  private szurKervenyLista(src: any[]): any[] {
    const f = this.kfilter;
    const search = (f.search || '').toLowerCase().trim();
    const statusKeys = Object.keys(f.status).filter(k => f.status[k]);
    const from = f.dateFrom || '';
    const to = f.dateTo || '';
    return (src || []).filter((row: any) => {
      // Szabadszavas keresés: kérvény neve + beküldő neve + ügyintéző
      if (search) {
        const hay = `${row?.data?.name || ''} ${row?.data?.submission?.data?.userMetadata?.full_name || ''} ${row?.ugyintezo || ''}`.toLowerCase();
        if (hay.indexOf(search) === -1) return false;
      }
      // Státusz (több is választható – VAGY kapcsolat)
      if (statusKeys.length && !statusKeys.includes(String(row.status))) return false;
      // Kérvény típusa
      if (f.kerveny && String(row.kervenyid) !== String(f.kerveny)) return false;
      // Beküldés dátuma tartomány
      if (from || to) {
        if (!row.date) return false;
        const d = moment(row.date).format('YYYY-MM-DD');
        if (from && d < from) return false;
        if (to && d > to) return false;
      }
      return true;
    });
  }

  // Élő szűrés: minden mező-változás ezt hívja; mindkét listát újraszámolja.
  /**
   *  A közös feladatkosár alapból csak a NYITOTT ügyeket mutatja: az elbírált
   *  kérvények (elfogadva / határozattal elfogadva / elutasítva) elvégzett feladatok,
   *  a kosárban csak zajt csinálnak. Egy kapcsolóval előhozhatók.
   */
  csakNyitottFeladat = true;

  private nyitottE(sor: any): boolean {
    const s = String(sor?.status ?? '');
    return s === '1' || s === '4';   // ügyintézés szükséges / hiánypótlás (a visszavont, 5 nem az)
  }

  applyKervenyFilters() {
    this.filteredSajatforms = this.szurKervenyLista(this.sajatforms);
    const kosar = this.csakNyitottFeladat
      ? (this.allforms || []).filter((s: any) => this.nyitottE(s))
      : this.allforms;
    this.filteredAllforms = this.szurKervenyLista(kosar);
  }

  toggleKStatus(k: string) {
    this.kfilter.status[k] = !this.kfilter.status[k];
    this.applyKervenyFilters();
  }

  aktivKSzurok(): number {
    const f = this.kfilter;
    let n = 0;
    if (f.search) n++;
    if (f.dateFrom || f.dateTo) n++;
    n += Object.values(f.status).filter(Boolean).length;
    if (f.kerveny) n++;
    return n;
  }

  resetKFilters() {
    this.kfilter = {
      search: '',
      dateFrom: '',
      dateTo: '',
      status: { '1': false, '2': false, '21': false, '3': false },
      kerveny: '',
    };
    this.applyKervenyFilters();
  }

  // A pillanatnyilag látható (menü szerinti) szűrt lista – a statisztikákhoz.
  get kAktivLista(): any[] {
    return this.menu == 6 ? this.filteredAllforms : this.filteredSajatforms;
  }
  kDb() { return (this.kAktivLista || []).length; }
  kVar() { return (this.kAktivLista || []).filter((r: any) => String(r.status) === '1').length; }
  kElfogadva() { return (this.kAktivLista || []).filter((r: any) => ['2', '21'].includes(String(r.status))).length; }
  kElutasitva() { return (this.kAktivLista || []).filter((r: any) => String(r.status) === '3').length; }

  menuChange(n) {
    this.menu = n
  }
  initForm(form) {
    //  Új kitöltés: ne az előző piszkozatra mentsünk rá.
    this.piszkozatId = null;
    this.aktualisKitoltes = null;
    this.menu = 3;
    this.loadForm(form.id)
  }

  onChange(event) {
    console.log(event.form)
    this.jsonElement.nativeElement.innerHTML = '';
    this.jsonElement.nativeElement.appendChild(document.createTextNode(JSON.stringify(event.form, null, 4)));
    this.refreshForm.emit({
      property: 'form',
      value: event.form
    });
  }

  async getBase64Image(url) {
    return await new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous'; // Important for CORS
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = reject;
      img.src = url;
    });
  }
  
  /**
   *  A PDF-be nem való felületi elemek elrejtése a képkészítés idejére.
   *
   *  A dokumentum az élő űrlapról készül, ezért minden rajta lévő gomb is belekerül.
   *  Csak a gombokat rejtjük: a kitöltött mezők, a szöveg és az aláírás maradnak.
   *
   *  @returns a visszaállító függvény – MINDIG hívd meg, hibaág esetén is, különben a
   *           felhasználó előtt is eltűnnek a gombok.
   */
  private gombokatElrejt(gyoker: HTMLElement | null): () => void {
    if (!gyoker) return () => { /* nincs mit visszaállítani */ };
    const valaszto = '.formio-component-submit, .formio-component-button, .btn-wrapper,'
      + ' button[type="submit"], button[name="data[submit]"]';
    const rejtett: Array<{ elem: HTMLElement; eredeti: string }> = [];
    try {
      gyoker.querySelectorAll<HTMLElement>(valaszto).forEach((elem) => {
        rejtett.push({ elem, eredeti: elem.style.display });
        elem.style.display = 'none';
      });
    } catch (e) {
      console.warn('A gombok elrejtése nem sikerült, a PDF-en rajta maradhatnak.', e);
    }
    return () => rejtett.forEach(({ elem, eredeti }) => { elem.style.display = eredeti; });
  }

  /**
   *  A KITÖLTÖTT MEZŐK KIBONTÁSA a képkészítés idejére (2026-10-19).
   *
   *  A PDF képként készül az élő űrlapról, és az egysoros beviteli mező képe az, ami a
   *  képernyőn látszik: a hosszabb érték vége levágódott („András Krisztina (anya) …
   *  Nagy Péter (apa) 2”). A mező helyére a képkészítés idejére egy azonos stílusú, de
   *  TÖRDELŐ, a tartalomhoz nyúló doboz kerül; utána minden visszaáll.
   */
  private mezoketKibont(gyoker: HTMLElement | null): () => void {
    if (!gyoker) return () => { /* nincs mit visszaállítani */ };
    const csere: Array<{ eredeti: HTMLElement; display: string; doboz: HTMLElement }> = [];
    try {
      const mezok = gyoker.querySelectorAll<HTMLElement>(
        'input[type="text"], input[type="email"], input[type="tel"], input[type="url"], input[type="number"],'
        + ' input:not([type]), textarea, select');
      mezok.forEach((m) => {
        const cs = getComputedStyle(m);
        if (cs.display === 'none' || cs.visibility === 'hidden' || m.offsetParent === null) return;
        let ertek = '';
        if (m instanceof HTMLSelectElement) ertek = m.selectedOptions?.[0]?.text || '';
        else ertek = (m as HTMLInputElement | HTMLTextAreaElement).value || '';
        const doboz = document.createElement('div');
        doboz.className = m.className;
        doboz.textContent = ertek || '\u00a0';
        //  A mező kinézete marad (keret, kitöltés, betű), csak a magasság nő a szöveggel.
        Object.assign(doboz.style, {
          whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', wordBreak: 'break-word',
          height: 'auto', minHeight: cs.height, overflow: 'visible',
          padding: cs.padding, border: cs.border, borderRadius: cs.borderRadius,
          font: cs.font, color: cs.color, background: cs.backgroundColor,
          lineHeight: cs.lineHeight === 'normal' ? '1.4' : cs.lineHeight, boxSizing: 'border-box',
          width: cs.width === 'auto' ? '100%' : cs.width,
        } as any);
        csere.push({ eredeti: m, display: m.style.display, doboz });
        m.parentNode?.insertBefore(doboz, m);
        m.style.display = 'none';
      });
    } catch (e) {
      console.warn('A mezők kibontása nem sikerült, a hosszú érték levágódhat a PDF-en.', e);
    }
    return () => csere.forEach(({ eredeti, display, doboz }) => { doboz.remove(); eredeti.style.display = display; });
  }

  /**
   *  OLDALTÖRÉS ELŐKÉSZÍTÉSE (2026-10-19): ami a laphatárra esne, az térközzel a következő
   *  lapra kerül, így egy mezőcímke vagy egy sor sem vágódik ketté.
   *
   *  A html2pdf a gyökérelem szélességét a lap hasznos szélességére (lapszélesség − 2 ×
   *  margó) méretezi, így a laphatárok pixelben kiszámolhatók. Az „egységek”: a legbelső
   *  űrlapelemek (formio-component, aminek nincs ilyen gyereke), táblázatsorok, bekezdések,
   *  címsorok. Ami egy lapnál magasabb, azt nem toljuk (úgysem férne el). Sorban haladunk,
   *  és minden beszúrás után újramérünk, mert a térköz a későbbieket is lejjebb tolja.
   */
  private oldaltoresElokeszit(gyoker: HTMLElement | null,
    beall: { format: string | [number, number]; orientation: 'portrait' | 'landscape' }, margoMm: number): () => void {
    if (!gyoker) return () => { /* nincs mit visszaállítani */ };
    const terkozok: HTMLElement[] = [];
    try {
      const lap = new jsPDF({ unit: 'mm', format: beall.format as any, orientation: beall.orientation });
      const lapSz = lap.internal.pageSize.getWidth() - 2 * margoMm;
      const lapM = lap.internal.pageSize.getHeight() - 2 * margoMm;
      const szel = gyoker.getBoundingClientRect().width;
      if (!(szel > 0 && lapSz > 0 && lapM > 0)) return () => { /* nincs mit visszaállítani */ };
      const lapPx = lapM * (szel / lapSz);
      const egysegek = Array.from(gyoker.querySelectorAll<HTMLElement>(
        '.formio-component, tr, p, h1, h2, h3, h4, h5, h6, .alert, img'))
        .filter((e) => !(e.classList.contains('formio-component') && e.querySelector('.formio-component')))
        .filter((e) => e.offsetParent !== null);
      for (const e of egysegek) {
        const g = gyoker.getBoundingClientRect();
        const r = e.getBoundingClientRect();
        const fent = r.top - g.top;
        const lent = r.bottom - g.top;
        const magas = lent - fent;
        if (magas <= 0 || magas >= lapPx) continue;
        const hatar = Math.ceil((fent + 1) / lapPx) * lapPx;   // a következő laphatár a teteje után
        if (lent <= hatar) continue;                            // nem lóg át
        const magassag = `${Math.ceil(hatar - fent) + 2}px`;
        let t: HTMLElement;
        //  Táblázatsor elé div nem tehető: egy üres, keret nélküli sor kerül elé, teljes szélességben.
        if (e.tagName === 'TR') {
          const sor = e as HTMLTableRowElement;
          t = document.createElement('tr');
          const td = document.createElement('td');
          td.colSpan = Math.max(1, Array.from(sor.cells).reduce((n, c) => n + (c.colSpan || 1), 0));
          Object.assign(td.style, { height: magassag, padding: '0', border: 'none', background: 'transparent' });
          t.appendChild(td);
        } else {
          t = document.createElement('div');
          t.style.height = magassag;
        }
        t.className = 'pdf-oldaltores-terkoz';
        e.parentNode?.insertBefore(t, e);
        terkozok.push(t);
      }
    } catch (err) {
      console.warn('Az oldaltörés előkészítése nem sikerült.', err);
    }
    return () => terkozok.forEach((t) => t.remove());
  }

  async onSubmit(event) {
    this.data.showLoading("Űrlap mentése és aláírása...")
    //console.log(this.form)
    const element = document.getElementById('urlap'); // your formio container
    setTimeout(async () => {
      const alertBox = document.querySelector('formio-alerts .alert.alert-success');
      if (alertBox) {
        await this.getBase64Image('assets/icon/certificate.png').then(base64 => {
          // Az aláíró a SAJÁT intézmény: a név korábban be volt égetve („Zenit Általános Iskola”),
          // így más intézmény kérvényén is a Zenit szerepelt aláíróként.
          const alairo = String(this.sajatIntezmeny?.intezmenyName || '').replace(/[<>&"]/g, '');
          alertBox.innerHTML = `<img style="float:left;margin-right:10px" src="${base64}" width="75"> <div><b>Elektronikusan hitelesített dokumentum</b><br><small>Elektronikusan aláírta:</small><br>${alairo}</div>`;
        });
      }


      const pdfBeallitas = this.getPdfBeallitas();
      const opt = {
        margin: 15,
        filename: 'form-submission.pdf',
        //image:        { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true
        },
        jsPDF: {
          unit: 'mm',
          format: pdfBeallitas.format,
          orientation: pdfBeallitas.orientation
        },
        /*  OLDALTÖRÉS: NE VÁGJON KETTÉ SEMMIT.
         *
         *  A html2pdf alapból egyetlen hosszú képet készít az űrlapról, és azt vágja
         *  oldalmagasságonként – vakon, a tartalomtól függetlenül. Így a lapok alján
         *  félbevágott sorok és kettétört táblázatsorok maradtak („Anyja neve" sor
         *  fele az egyik, fele a másik oldalon).
         *
         *  Az `avoid-all` minden elemre megnézi, hogy oldalhatárra esik-e, és ha igen,
         *  átteszi a következő oldalra. Az egy oldalnál MAGASABB elemeket békén hagyja
         *  (azokat úgysem lehetne egyben tartani), tehát nem tud végtelen üres oldalt
         *  gyártani. Ára: néha nagyobb üres sáv marad a lap alján – ez jobb, mint egy
         *  félbevágott mondat egy aláírt dokumentumban. */
        //  2026-10-19: az `avoid-all` a gyakorlatban így is kettévágott sorokat (élesben egy
        //  kérvény mezőcímkéje a két lap határán). A laphatárokat most mi számoljuk ki és toljuk
        //  át a ráeső elemeket (oldaltoresElokeszit) – a html2pdf csak a CSS-töréseket nézi.
        pagebreak: { mode: ['css', 'legacy'] }
      };

      /*  A GOMBOK NEM VALÓK A PDF-BE.
       *
       *  A kép az ÉLŐ űrlapról készül, azon pedig ott a „Submit" gomb – bele is került
       *  a kész, aláírt dokumentumba. Elrejtjük a képkészítés idejére, és utána
       *  visszaállítjuk: `display:none`-nal a helyét sem hagyja üresen, tehát nem lesz
       *  tőle egy plusz, üres oldal sem. */
      const gombokVissza = this.gombokatElrejt(element);
      const mezokVissza = this.mezoketKibont(element);
      let toresVissza: () => void = () => { /* még nincs mit visszaállítani */ };
      const mindVissza = () => { toresVissza(); mezokVissza(); gombokVissza(); };
      //  A visszajelzéshez: a flaget menet közben nullázzuk, de a végén még tudni kell.
      const ujraE = !!this.ujrageneralando;

      const images = element.querySelectorAll('img');
      Promise.all(
        Array.from(images).map(img => {
          return new Promise<void>(resolve => {
            if (img.complete) {
              resolve();
            } else {
              img.onload = () => resolve();
              img.onerror = () => resolve(); // Still resolve to avoid hanging
            }
          });
        })
      ).then(() => {
        //  A képek betöltése után: azok is módosíthatják a magasságokat.
        toresVissza = this.oldaltoresElokeszit(element, pdfBeallitas, opt.margin);
        return html2pdf().set(opt).from(element).outputPdf('blob').then(async blob => {
          const formData = new FormData();
          formData.append('file', blob, 'form-submission.pdf');
          formData.append('intezmeny', this.sajatIntezmeny?.intezmenyId || '');

          const jegy = formioJegy();
          const alairas = await fetch('/api/forms/sign', { method: 'POST', body: formData,
            headers: jegy ? { Authorization: 'Bearer ' + jegy } : {} });
          const response = await alairas.json();
          if (!alairas.ok || response?.status === 'error') {
            throw new Error(response?.error || `Az aláírás nem sikerült (HTTP ${alairas.status}).`);
          }
          console.log('✅ Server response:', response);

          // A kitöltést a formio submit-eseménye hozza (`event`), NEM a betöltéskori
          // `this.form.submission`: az szerkesztőből érkező űrlapon hiányozhat, és a
          // felhasználó által beírt értékeket sem tartalmazza.
          const body = {
            form: { ...this.form, submission: event || this.form?.submission || { data: {} } },
            response: response,
            userid: this.user$?.username,
            // Határozat esetén ez köti a beküldést az eredeti kérvényhez.
            hatarozatkerveny: this.hatarozatEredeti,
            // Ha piszkozatból készült, a beküldés után annak nincs többé értelme.
            piszkozat: this.piszkozatId,
          }

          /*  ÚJRAGENERÁLÁS vagy ÚJ BEKÜLDÉS.
           *
           *  A PDF elkészítése és aláírása mindkét esetben ugyanaz – csak a vége más:
           *  az újragenerálásnál NEM születik új kérvény, hanem a meglévő sor kapja meg
           *  az új PDF-et. Ha itt a `/send` menne, a javításból egy második, párhuzamos
           *  ügy lenne, és az ügyintéző nem tudná, melyik az érvényes. */
          if (this.ujrageneralando) {
            await firstValueFrom(this.http.post(
              '/api/forms/ujrageneral/' + this.ujrageneralando.id,
              { path: response.path, form: body.form, ugyintezo: this.user$?.username }));
            this.ujrageneralando = null;
          } else {
            await firstValueFrom(this.http.post('/api/forms/send', body));
          }

          this.hatarozatEredeti = null;
          this.piszkozatId = null;
          this.aktualisKitoltes = null;
          this.piszkozatokBetoltese();
          this.options = options
          this.form = { components: [], display: 'form' };
          this.menu = 1;
          setTimeout(() => {
            this.rebuildEmitter.next(this.options);
          }, 1000);
          this.data.hideLoading()
          this.data.sendToast(ujraE ? "A kérvény újragenerálva." : "Űrlap sikeresen beküldve!", "success");
          this.ngAfterViewInit()
        });
      }).catch(err => {
        // A kitöltött űrlapot szándékosan MEGTARTJUK: hiba után a felhasználó újra tud
        // próbálkozni anélkül, hogy mindent újra begépelne.
        console.error('❌ Kérvény beküldése sikertelen:', err);
        this.data.hideLoading()
        const uzenet = err?.error?.error || err?.message || 'ismeretlen hiba';
        this.data.sendToast(`Az űrlap beküldése sikertelen: ${uzenet}`, "error");
      }).then(() => mindVissza(), () => mindVissza());
      //html2pdf().set(opt).from(document.getElementById('urlap')).save();
      //html2pdf().from(element).set(opt).save();
    }, 100);
  }

  /** ?sablon=<id> → az adott sablon szerkesztője nyílik meg (dokumentum-sablonokhoz). */
  private sablonParaméterNyitas() {
    try {
      const params = new URLSearchParams(window.location.search);
      const id = params.get('sablon');
      if (!id) return;
      const sablon = (this.forms || []).find((f: any) => f.id === id);
      if (!sablon) return;
      this.selectedForm = sablon;
      this.loadEditor();
      // Csak egyszer nyissa meg (különben minden lista-frissítésnél visszaugrana).
      window.history.replaceState({}, '', window.location.pathname);
    } catch (e) {
      console.error('Sablon-paraméter feldolgozási hiba:', e);
    }
  }

  async ngAfterViewInit() {
    /*this.prism.init();*/
    this.user$ = await this.data.getFromStorage("user")
    this.http
      .get(
        '/api/forms/all',
        {

        }
      )
      .subscribe({
        next: (response: any) => {
          //this.allomany = response
          this.forms = response
          this.csakhatarozat = response.filter(d=>d.tipus=="hatarozat")
          this.formseredeti = response.filter(d=>d.tipus=="hatarozat")
          // A dokumentumgenerátor sablonjai (tipus='dokumentum') nem kérvények:
          // azokat csak az adminban lehet generálni, itt nem szabad megjelenniük.
          this.csakkerveny = response.filter(d=>d.tipus!="hatarozat" && d.tipus!="dokumentum")
          this.kitolthetoKervenyek = this.csakkerveny.filter((d:any)=>!this.lejart(d))
          this.buildKervenyFacets()
          // A dokumentumgenerátorból ?sablon=<id> paraméterrel érkezve rögtön a
          // szerkesztő nyíljon meg az adott sablonon (ne kelljen kikeresni a listából).
          this.sablonParaméterNyitas()
          this.piszkozatokBetoltese()
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        }
      })


      this.http
      .get(
        '/api/forms/usersent/'+this.user$.username,
        {

        }
      )
      .subscribe({
        next: (response: any) => {
          //this.allomany = response
          /*this.sajatforms = response.filter(d=>!d.hatarozatkerveny)
          this.sajatforms.forEach(e => {
            if(e.hatarozatkerveny) e.status = '21'
          });*/
          // A határozat NEM önálló kérvény: az eredeti kérvény sorára kerül rá
          // „Határozat" gombként (hatpath), és a lista nem mutatja külön sorként.
          let sajatforms = response
          sajatforms.forEach(e => {
            if(e.hatarozatkerveny){
              let f= response.find(o => o.id == e.hatarozatkerveny)
              if (f) {
                /*  A HATÁROZAT LÉTE NEM JELENT ELFOGADÁST.
                 *
                 *  Itt korábban feltétel nélkül '21' (= „Elfogadva") lett a státusz,
                 *  valahányszor készült határozat. Elutasító határozatnál ez a
                 *  beküldőnek azt írta volna ki, hogy elfogadták az ügyét. A már
                 *  meghozott döntést (2/3/4/5) ezért nem írjuk felül; a '21' csak
                 *  ott marad, ahol döntés még nincs rögzítve.
                 */
                if (String(f.status) === '1') f.status = '21'
                f.hatpath = e.path
                if (!this.sajatforms.find(o => o.id == f.id)) {
                  this.sajatforms.push(f)
                }
              }
            }else if(!this.hatarozatSor(e)){
              let f= this.sajatforms.find(o => o.id == e.id)
              if(!f)
              this.sajatforms.push(e)
            }
          });
          this.buildKervenyFacets()
          this.applyKervenyFilters()
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        }
      })

      //  A munkakosár csak a munkatársé: a szülőnek/diáknak a kiszolgáló úgyis üreset adna.
      if (this.loginmode !== 'gondviselo' && this.loginmode !== 'tanulo')
      this.http
      .get(
        '/api/forms/sent',
        {

        }
      )
      .subscribe({
        next: (response: any) => {
          //this.allomany = response
          
          response.forEach(e => {
            if(e.hatarozatkerveny){
              let f= response.find(o => o.id == e.hatarozatkerveny)
              if (f) {
                // Lásd fent: elutasító határozatnál a '21' „Elfogadva"-t írna ki.
                if (String(f.status) === '1') f.status = '21'
                f.hatpath = e.path
              }
            }
          });
          // Se a kapcsolt, se a (régi, kapcsolat nélküli) határozat nem kerül külön sorba.
          this.allforms = response.filter(d => !d.hatarozatkerveny && !this.hatarozatSor(d))
          this.buildKervenyFacets()
          this.applyKervenyFilters()

        },
        error: (error) => {
          console.error('Error fetching data:', error);
        }
      })
    
  }

  private normalizePdfMeret(meret: any): string {
    const value = String(meret || '').trim().toLowerCase();
    return this.pdfMeretek.some(m => m.value === value) ? value : 'a4';
  }

  private normalizePdfFekves(fekves: any): string {
    const value = String(fekves || '').trim().toLowerCase();
    return value === 'landscape' ? 'landscape' : 'portrait';
  }

  private getPdfBeallitas(): { format: string | [number, number]; orientation: 'portrait' | 'landscape' } {
    const source = this.form?.pdfBeallitas || this.selectedForm || {};
    const meret = this.normalizePdfMeret(source.pdf_meret);
    const orientation = this.normalizePdfFekves(source.pdf_fekves) as 'portrait' | 'landscape';

    if (meret === 'custom') {
      const width = Number(source.pdf_szelesseg_mm);
      const height = Number(source.pdf_magassag_mm);
      if (Number.isFinite(width) && Number.isFinite(height) && width > 0 && height > 0) {
        return { format: [width, height], orientation };
      }
    }

    return { format: meret === 'custom' ? 'a4' : meret, orientation };
  }

  initPdfBeallitas(formLike: any = this.selectedForm) {
    if (!formLike) return;

    formLike.pdf_meret = this.normalizePdfMeret(formLike.pdf_meret);
    formLike.pdf_fekves = this.normalizePdfFekves(formLike.pdf_fekves);

    if (formLike.pdf_meret === 'custom') {
      formLike.pdf_szelesseg_mm = Number(formLike.pdf_szelesseg_mm) || 210;
      formLike.pdf_magassag_mm = Number(formLike.pdf_magassag_mm) || 297;
    } else {
      formLike.pdf_szelesseg_mm = formLike.pdf_szelesseg_mm || null;
      formLike.pdf_magassag_mm = formLike.pdf_magassag_mm || null;
    }
  }
  async loadEditor(admin=false){
    
          if(this.selectedForm.erv_kezd) this.selectedForm.erv_kezd = moment(this.selectedForm.erv_kezd).format("YYYY-MM-DD") || null
          if(this.selectedForm.erv_vege) this.selectedForm.erv_vege = moment(this.selectedForm.erv_vege).format("YYYY-MM-DD") || null
              this.initPdfBeallitas(this.selectedForm)
              if(this.selectedForm.hatarozat) this.selectedHatarozat = {id:this.selectedForm.hatarozat,name:this.forms.filter(d=>d.id==this.selectedForm.hatarozat)[0].name}
              else this.selectedHatarozat = null
    this.loadForm(this.selectedForm.id)
  if(!admin)
    this.menu= 4
  }
  async saveEditor(){
    await this.data.showLoading("Adatok mentése...")
    const body = {
      display:this.form.display,
      components:this.form.components,
      formid: this.selectedForm.id,
      formdata: this.selectedForm,
      hatarozat: this.selectedHatarozat?.id || null
    }
    console.log(body)
    this.http
      .post(
        '/api/forms/save',
        body
      )
      .subscribe({
        next: (response: any) => {
          //this.allomany = response
          console.log(response)
          this.data.hideLoading()
          this.data.sendToast("Űrlap mentve!","success")
          this.ngAfterViewInit()
        },
        error: (error) => {
          this.data.hideLoading()
          this.data.sendToast("Űrlap mentése sikertelen!","error")
          console.error('Error fetching data:', error);
        }
      })
  }
  
  /**
   *  Űrlap betöltése a szerkesztőbe. A `hatarozatEredeti` alapból nullázódik: csak a
   *  határozat-generálás állítja be, hogy a beküldés az eredeti kérvényhez kösse magát.
   */
  async loadForm(id, submission = null, hatarozatEredeti: string | null = null){
    this.hatarozatEredeti = hatarozatEredeti;
    await this.data.showLoading("Adatok betöltése...")
    this.http
    .get(
      '/api/forms/get/'+id,
      {

      }
    )
    .subscribe({
      next: async (response: any) => {
        //this.allomany = response
        this.data.hideLoading()
        const kapcsolodoSzulok = await this.getKapcsolodoSzulok()
        const sajatGyerekek = await this.getSajatGyerekek()
        const gyermekAdatok = sajatGyerekek.reduce((acc: any, gyerek: any) => {
          if (gyerek?.formKey) {
            acc[gyerek.formKey] = gyerek
          }
          return acc
        }, {})
        this.form = response.data
        this.form.name = response.name
        this.form.id = id
        this.form.pdfBeallitas = {
          pdf_meret: this.normalizePdfMeret(response.pdf_meret),
          pdf_fekves: this.normalizePdfFekves(response.pdf_fekves),
          pdf_szelesseg_mm: response.pdf_szelesseg_mm,
          pdf_magassag_mm: response.pdf_magassag_mm,
        }
        const baseData = {
          "sajatIntezmeny": this.sajatIntezmeny,
          "user": this.user$,
          "userMetadata": this.userMetadata,
          "szulok": kapcsolodoSzulok,
          "kapcsolodoSzulok": kapcsolodoSzulok,
          "mindketSzuloAdatai": kapcsolodoSzulok,
          "gyerekek": sajatGyerekek,
          "sajatGyerekek": sajatGyerekek,
          "gyermekAdatai": gyermekAdatok,
          "gyermekAdatok": gyermekAdatok,
          "gyermekekByKey": gyermekAdatok,
        }
        this.form.submission = {
          "data": baseData
        }
        //this.form.options.noAlerts = true;
        if(submission){
          this.form.submission = {
            ...submission,
            data: {
              ...baseData,
              ...(submission?.data || {})
            }
          }
        /*this.form.submission = {
          "data": {
            "felugyelet": 1,
            "video": true,
            "kelt": "Göd",
            "dateTime": "2025-04-01T18:04:28.000Z",
            "alairas1": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAjYAAACWCAYAAADNNcLyAAAAAXNSR0IArs4c6QAAHzlJREFUeF7tnX+IXtWZx48/YCMTdrJNjdCYCdiq22yrVFuFaArSuhgIrEsppsxABYszNDVCwYBJYXfpNqEb6GJEyfypZDDBgrKVTansyjZxQKmyzbppja2Q1x+LFbuOSyD5xy7PfX3enDlz33nvve/9cX583n/yY+495zmf59y53/c5z3nOJefOvf8nwwcCEIAABCAAAQhEQOAShE0EXmQIEIAABCAAAQhkBBA2TAQIQAACEIAABKIhgLCJxpUMBAIQgAAEIAABhA1zAAIQgAAEIACBaAggbKJxJQOBAAQgAAEIQABhwxyAAAQgAAEIQCAaAgibaFzJQCAAAQhAAAIQQNgwByAAAQhAAAIQiIYAwiYaVzIQCEAAAhCAAAQQNswBCEAAAhCAAASiIYCwicaVDAQCEIAABCAAAYQNcwACEIBASQK//OWL5sSJF83CwjFz++1bzSWXXGJ6vV7Wytmzb5nNmzdlf5+amhq0PDV1tdm8+eK/+z/vXycf+ZneV9IcLocABCwCCBumAwQgAIFVCIhQOXu2lwmZkycXM+GybdttZtu2rWZmZufgTvn/vrDpmV6v//cTJxYHP1fhI6JotY8rfkTsqECyxZGIIsQQUxcCKwkgbJgVEPCAgLwUjxx5Kntx6uf1198wa9b8mdm7d0/2IuXbfLOOUmEifuj13s4iMBp9kaiM+OCrX72tFiO0r7746QudviB6O/u7Hf2R/x/1UYEjAkgEl4ieumwd1Tc/h4BvBBA2vnkEe5IgYEcB5MVmf7MfBmDv3ofMzMy3EDg1zxAVlfv3H8wiINPT99QqYuowV+eLGwkSAbRaBEjGo9ElxE4dnqCNEAggbELwEjYGT0BfnjIQicrkvYz0parRgmEvrNOnX0Xc1DAjbEEjonHfvj01tNpNE7bwEZE8TPBoZGd6eidRnW5cRa8tEEDYtACZLtIjYC8tDRMo8pK56qoNZsOGK82uXbO5Swdy74EDB5cJIVliOH782fSg1jhi4bp9+90Z88OHH41WKMo81IhgntixIzp2vlCNqGkKAq0TQNi0jpwOYyQwSsjoN2XN1Sib9KkvYmU3P//ossTVGJk2NaYf/eifjCw7hR6lqcLHFjqSS2R/bJFDTlcVutzjCwGEjS+ewI4gCOiLQRI6L1y4kOXGvPzyr1bYrstK8oO68mK2bLk5SzCVz/r1683Ro0+YrVtvDYKbL0bOzu7OkrQl4pV6cq2dLO0uj+rOLB/zjXyZS9jhLwGEjb++wTIPCIyKxKiJbSSdaqRB+9yxY7s5duxJDyj5b4L4cW7ugWxJD1GT7y8V7QsLR1fkgOn8rkuk+z9jsDBkAgibkL2H7Y0REBEhxdc0QmJvp5VaIvJZu3at+dKXbmz1m//ExJWDMctLZn7+UGMMYmlYRY38efjwoVb9FSpDRE6onsNuIYCwYR5A4BMC9i4Z+a82ojBl4It9W7bchLApA80Yc911N5p33nmXSE1Jbnr5qLycfhmCi4UKK3bDbRCojQDCpjaUNBQqAVfQSO7Fww8/5OU3eztiw+6o1WecJlyvWzdpFhdfiHbnU5vP3bBIjr2NHJHTpkfoK48AwoZ5kSSBYdEZ32uZIGyKTVfZyi3CxmeRWmwk/l61msjJO3LC35FgWWwEEDaxeZTxrErAFjSTk5Nm1677vasyO2wALEWNntwiZubmdme5USlu5x5NqJkrhiXZr107YWZn7zP33XcvEbNm0NNqDgGEDdMiGQL2rqIQX3qusAlxDE1ONvUvUZomKY9uW0XOc88dN6dOvZbdgE9Gc+OK+gggbOpjSUueErC/xUsuQKg7Y3R5RTFztEKfhF2dGbHn10Po7i5E4Pjln1itQdjE6lnGlZ3MrLVLBEcdLz3NK5ADBctWDx7HJUeOHDWzsw8MmpC+T59+ZZwmo7hXozQhC9YoHLHKINzn0I7gtPkMxc6Z8V0kgLBhNkRHQH6RSsl8LRkvvzylKNvmzZvGGmtXS0FuvzIIisyZ7KwnTRDm7KyxpnYrNw8790wO5OQIh1ZckEwnCJtkXJ3GQO08Gq1DU9dOJ7fyrxBtYznojju2Lzu2IXVRY0cA6ojCpfFk+DNKe2lYrZIlKhE4bBX3x08hW4KwCdl72D4g4IqOJqryustBTUZONAHzN7953TzzzL8Mxpn6i5yjEeJ56IcJnJhPW4/He36PBGHjt3+wbgQB95djk7kW7gnbYlrdp2y79XXs4d9559fMs88eTXZOIGridH3e8SV1LB3HSYtRFSGAsClCiWu8I+Dm0YiBbUQz7BO2pc+6IkMyHskZ0bOpXOAbN37GnDnza+/80JZBiJq2SHfTT16CcRvLvN2Mll6bJoCwaZow7ddOwF12kvX5tsLX7pbrcY81yPuFrsDqzhGq3REtNqjc646QtTgEuipAwM2RI3JTABqXrCCAsGFSBEMgb9lpevoeU1dycBEQs7O7B7ut9Ppz594vcuuKa/KWtlTMSCRo3F1clYzy8CYVNXVFxzwcIiZZBOxnrK4djQBOiwDCJi1/BznavLyTcSMlVUHkJRBXCZnniZo2ltKqjrur+/Ql15W/uxp36v3akVGei9RnQ/nxI2zKM+OOFgm4AqDJ5OAiw8oTJGWFjVuXpusxFRl3F9fs2fMD89hj8+aWW75sXnjheBcm0GdHBNycM8RNR44ItFuETaCOS8HsvFwaHwqxuQnEZZei7G+jhNrzZ7JGxq66aoN5883/TmG6M0aHgCtuyn6BAGi6BBA26fre25G7v9Dk5S/f2Hwp3uXm2RT9hZuXKJx6sb28SWhHxYqy9XYyY9hYBEgmHgtfsjcjbJJ1vZ8DzzsTybedEY888rjZu/fvBgCLRGzyqhYjalbOQXuZDj5+PqNtW2V/kdixY7s5duzJtk2gv8AIIGwCc1jM5rpbqX1dV3/66WfMvffeP3DFalGF++9/wCwsLC+qR07N8FmsAtBX38f8/Pk8tqmpvzQffPBBZiJzw2dP+WEbwsYPPyRtRd7S0+HDh4zshPHx4yb/DhM211zzV+a99/4wGAJ1aUZ7U8UtL6/RrFK6Qr5MPPjgQ2ZpacnwHKXk+WpjRdhU48ZdNRFwdxmFsK3XtXmYsNHDKycnJ80jjxw03/zm39ZELd5mJiauzAZHIb54fVx1ZPYXIKKeVSmmcR/CJg0/ezlKN+8klG/pRYWN/YuYF/XoKbi4+JK5884d2YX79/+DefDB746+iSuSIuCKm9OnX0lq/Ay2GAGETTFOXFUjgbzdQSG9+N2lqNWSXCkwV3zi2IKRxOHi3FK70n7+Qvq9kZqfuhwvwqZL+gn2HVo+TZ6Lyggbe5eXRKS2bbstyxHguISVZO0IHsImwV8OJYbMF4YSsBK8FGGToNO7GrK7lTvks380F0RYjqq14hb0U2Hz8MMPIXKsyWgLm1FMu5rD9OsHAcoC+OEHX61A2PjqmcjsCjWfZpgbyggbWWI5cOCgkT/zPjfc8AUj9TlE8PQjOpsi836x4dj1ShA2xZilfBU76FL2/upjR9gwNxoncMMNt5rf//7NQT+hLzO4S1FFCvTJ4EXYLCwcMydOvGjOnu0N5a4CRy7Ytm2rmZra5O3W9zonD8KmTprxt6VflkLYSRm/N/waIcLGL39EZY2bT7N+/Xpz4sTzwUckbGFz+eWXm6Wl/yntN1mWk8J9w6I4boO6fDU1JVGdOMWOvVQZuvgtPSG4oTQBfQ5j+b1SGgA3DCWAsGFyNELAzaeRXz693m8b6avtRqtGbPLslC3OL7zwH+bkycXCIkfbEbHTj+rcFoXYsXdF8S287VkdZn8aDWZ3VJj+a8pqhE1TZBNu1z0aIbaXlFvHpuhS1KgpIYJJPrJUdeLEoun1eqXFjtyvS1kS2VHhE0rejj13eFmNmjH8XJejQt6IgBfrJ4CwqZ9psi3m1aeJTdSIc5sSNsMmjnCVnJxe761M8IzK0clrx13K8jVJ2WYrNvt2AGqyD7fHA9ddhySce+yklk1D2LQMPNbu3HwaGWcolYTL+qRtYZNnnyt2qkR3fM3bsZOIv/3tGfP44/9c1kVcnxABjdoQ4UvI6SOGirBhLoxNwM05kQZj/iXjg7AZJnbGXcryQezknR92+PCjwSedj/2g0UAuAZ0vMf/OwfXlCCBsyvHiaodAnqiJfUdLncnDTU+oOvJ2ukhSvvvue8zzz//7Mjy8uJqeLeG2L3WlYo0Qh+uV7ixH2HTHPoqe3UTh2EWNOM0WNvLSD/EgPhmD5upU2ZElHOwk5SZq7cg38bm53ctq/iBuovi1Uesg9HlE2NSKNejGEDZBu69b41MUNbEIm2FLWSJ2+stZi+bIkadKTzAVO1NTV9dyLtaw3C3ZBRPKTq/SELmhFAHNsalrd2KpzrnYSwIIGy/d4r9Rbp2alL4t2RGbjRs/Y86c+bX/DqtooS9Jyu55WzIc2XEn521JkcStW2+tOEJuC52AfMGSwpXz84dCHwr210QAYVMTyJSayUvulCWoVD62sJmcnDTvvvu7VIaejbMusSNtlSkuKLulhm11Z4kqqSk4GCzLUGn6fdSoETajCPHzZQRcURNqjsm4btVDMGOqqDwOk7aSlFc7b0uWpyRyyBLVOJ4M616WocLyV1vWImzaIh1BP+7y09q1E+bppxeSOKDRdl8MycNtTUdNUpb+ypyNZdvnVlKemdmZ/VhEzg9/eMDIsRT6kWtF3Og1bY2TfrohMDNzn3n11f8MMoG/G2Jp9IqwScPPY4/STRSWBn/843803/ve7Nhth9iARmxSjViN47O6lrIkMiO5FZdddpn5+c9/Yd577w8Ds4jejOOhMO7VLxgp/x4Kw1PtW4mwaZ95cD3miZqUkoVdhxGxqX8K17GUtWbNGnP+/Pllxknuja/HR9RPMa0WZRlqYeEY0Zq03F5otAibQpjSvUjXsG0CMZ7/VMbDCJsytMa71l7KqnowqAieu+76ayNLp3IwaBM1d8YbJXeXJaDPIEnjZcmlcT3CJg0/VxplXlVhaSj1w+YQNpWmU2035UV3dHmraCd51ZT1OImibXBddwR0h1yIxTG7o5ZOzwibdHxdeqT2YYR6M9+Q4qg8XHoyBHCDm7tz6tR/mVOnXitluQ9nZZUyOMGLdWdmClXOE3RvLUNG2NSCMb5GhkVrqO6JsAlttu/Z8wPz058+M0guvvTSS83HH39cahgInlK4Gr1Ycv7kk1LtrEaBRtg4wiZCp9YxpLyEYaI1fbIsRdUxw9ptQ77l33vv/ct2Tu3aNWu+8pWbzYULF7IjJHq9XmaUXFv0g+ApSqqe64jW1MMx9lYQNrF7uML4iNaMhsZ279GMfLxCojePPTY/MC2v7o3m8Jw92zO9nhwW2hc9CJ7uPUq0pnsfhGABwiYEL7VsI9Ga1YETsWl5Qtbc3bCDNfft2zOyJzePR24oI3qI8IxEPPQCLRCa+uaF6gTTuRNhk46vC48078BBcmuW4yNiU3g6eXmhCBQ5vXz//oPLojfT0/eYIgInb1C26OlHe94uLHrydmlJWQU+FwnIM5dy/SzmQnECCJvirJK50q1dQ27NStcjbOJ4HGR5aW5utxEhoh8RGYcPH6r1qBB7i3oZ0ZMX4UlxW7pEkYUh27vjeO6aHgXCpmnCAbav32ZPnlw0t9++tfI32ACHXthkhE1hVN5fmBe9EaPlWAaJ4DQdObEjPdKv5vSsVpvHjvBMTV1t5N+xFh4kYdj7R8g7AxE23rkEg0IggLAJwUvlbBQhMTf3wIok4bYEzrDlrb7Y6e/UEtEjH8nrGSZ8Ysrj0Xw2lqDKzeXUr0bYpD4DGH8lApqHlPrxEpXgeX7TMIHj48nhtrixd3AJYncXlx3lkZ+HcLwEu6A8f1g8NQ9h46ljMMtvAggbv/1Th3UiGiS5WJKM7Y8IhHGSjOuwrWgbdm6PRnzydnHJmOSwUJ8ED3k1Rb3MdS4BhA1zAgIVCCBsKkAL9BbNwZGTpN0k41AETh56t16Pm9RsJylPT+/Mcnjk03TyskbMSBYO9IHxwGyEjQdOwITwCKiwkfyL+flD4Q0AiysRkFoqkudiR3FCiuCUHbS91KV5PrKpYGpqypw584a57rprs3wf2WSgmw3055rULH0WFUWaU8MSb1lPcb1NAGHDfIBABQIImwrQIrolbydVii9j4bB586YskVn+lLwezeXRys3ido10aW0fEUYilOQe+bt8Nmy40vzkJ4ey3Wh8WYjoYelgKAibDqDTZfgEEDbh+7COEdjLVJKjwgu5HFXh9/LLv8oEjZzEfuedXzMXLpzPhJJ8hKkkOWvUR0WTCCI+EBhGAGHD3IBASQL2rhm2oZaEx+UQsAhogUQRKocPP5pFcPTjJj5rDpD8XA8slWiP/XcbriyFSYRI/xSBpJGjmOv+MMGMQdgwCyBQgIDkVuzd+/fm8ssvW3ZC9Kc/vd58/vPXf/LN8rbGi7kVMJVLIBAEAa1wXueXAxVDuiwmy4O6PKZLZgJHlsFE5Eg+kNwjkaE2ijEG4ZgIjETYROBEhtA8geuuu9G88867IzvSbbMh1AgZORgugEADBOxdT3UfXVHFXLFHhI6eG+aDTVXGwT0XCSBsmA0QKEDg6aefyc4UOn/+vFmzZk32Z5FPTFVgi4yXayCwGgEREVKfxsd8JK1bJCJH7JNIErk8Yc5nhE2YfsPqjghI+NyuZ/KpT/2F+eMf/7e0NW5BNPlFyi/R0hi5ISACuvTk86G67m6306df5bkMaI6pqQibAJ2Gyd0TuOmmreb1198wk5OT5sKFC9k3PNmu+tZbb60oZV/UWo3uSE0Q+fvMzM6it3JdpAQkP+TAgYPZluhQIwi+LT0VmSqLiy+Z73znu15GlorYn/o1CJvUZwDjr0RAwuny0hERcsUVV5jnn/+3rB2pwfH1r99hbrnly9m6vRRz00TFKh3ZOTsInSoEw71Hi9XpCOpMsm2Liooa6e/48Wfb6raWfmZnd2eFGEPkXguAgBtB2ATsPEzvjoAKGy0mpgmIWpXWrUarFVz1oEKxfLUTmlcbmV3LQ4ubuVVeqffR3dyoq2cRznoIpLQpPj19+pW6mm+sHXs55/rrrzXf+MbdZt++PY3111TDshNydvaBbKdjaKKsKSahtIuwCcVT2OkVgdUK9KmIkVwcES8iPmSX1GoRF/fcHhmsiCQVQO5JzUVhuAJHbFERpGXu9aVJjk9Rqu1cpy9W7c33irySQ6Pbp2XrdMjLqXa0jIhNO/O9zl4QNnXSpK1kCJSpPKzRnIWFoxkfWb6SnBz5JljmYxcsE1FiR3/GiQDZNuRFg+TndvVXFUJ6H4KojBeLX6vJtnqHjy9Yt/LyKAFffPTdXnnXXX8z+GJBAnG3vqjSO8KmCjXuSZ5A1dO97SWryck/N0tLH2Wioe5dUXkRILdyq33AYR0OzYsOacTKrf46MTFhpLihCLSmT4uuY2xdtKHLndq3LIeUFcNN2G2LGRG1ItRDXGrKY+Mu/332s9eYU6deagIjbTZIAGHTIFyajpeAht0ffvihsV42ttCxX/5tJgqrCBJvXTyssH9Wz/L/e3vwf1rGfjUPuwck2v9WUaf9STsqjLRN+4BEd/ksBTE0MXHlMrznzr3f6QMlL31JhJclVllqkqWxmKJ1boRM5hjF+jqdcpU7R9hURseNEKifQF3LVvVb1lyLdnRJepEltrzoki2ybGtsQaQvWk2qlutEFLnCyc4vGiaq7PL8/b77J1jbH/f/XDGn9y23N/8AR7std0dUV4nDbnRmXCHf3Cyq3rIWDbRFtu/5TNVHm8adCJs0/MwoAyRgR3Pkm3LoCZl1usBeRhMhpB9bEPVFUs/6Wf86+wVWp01l2nKjUyvv/dPghGv5mdRLWrduMhNWeeJJrpEloaWlJbO09H/ZuKend2Zj1QMf7T50SWvYkqUmAUt/0k6bEcQyHMe9lijNuAT9vB9h46dfsAoCKyID/Ze2nGuzmL24qiYhg7ZPwBYINhMVA/ZJ0HliSASDXrsa0yrLNZrDpe1WSWDVwx9FFGuy+bATsu2ollzrQy5Pk/M0L0rDtu4mibfbNsKmXd70BoFaCLjRHE3ijC3voRZYgTXiyzJUYNgKm5sXpZEdZ7FGpQqDiehChE1EzmQo6RKwc3Pk77LLSr6FI3TCmxPui9fns5VCokuUJiRvjWcrwmY8ftwNAS8JyDKE7F6Rj55W3MS2ci8HH7hRtrDpKmk4cIQrzM+L0kjOWizb1GPz17jjQdiMS5D7IeA5AXvZSpNpyc/x12kbN37OfPjhUmagj0X5/CW30jIR+HNzu5cljJNLE5IHq9mKsKnGjbsgECyB1YROCvVhfHace4xClaRhn8fXlm26TX3//oODLt3z29qyhX7aJ4CwaZ85PULAKwJ5QkfqwEioPvbdMV45whhjF+Wjlko177jLTtIKLKuxDPUuhE2onsNuCDREwBU6mowsOTopbAVuCOvIZmdnd5sjR54aXNd1peGRBnt2Qd6yE9WDPXNSS+YgbFoCTTcQCJWAu7VcxiG7rmI58NAHv7hbvH05F8oHNqNsEHZzcw8YETb6YdlpFLW4f46widu/jA4CtRPIi+hoHZ0qp5bXbmCADdrRGpJbizlQ5qHk0NhRLgRNMXaxX4Wwid3DjA8CLRDQAxKlFL/k51AZuRx0O7eGaM3q7EgMLje3UrwaYZOi1xkzBBokoOcP9U+CPjroSbaYyzdqKrwuh2/vhCJaM3xiEqFp8KGNrGmETWQOZTgQ8JGAfssW23q9t4noWE6yz4UiWrNy9iJofHyi/bYJYeO3f7AOAlES0NO5Jaojy1fy0S3mKdXSsaM1VBlePtXzkoL7Zzp9KzvlnA8EhhFA2DA3IACBzgmo0JHTy3X56otf/ILZsWN71LV0iNasnHpSh0aOA7FPV+f4g84f0aAMQNgE5S6MhUA6BBYXXzJPPLGQDTjG867sQnLk1hjjChphMj29k5ysdB752kaKsKkNJQ1BAAJNEdAcHVm2kh1YsmwjW8tDrY4sY9i+/e4BrlSPTnB3OLFdu6knKK12ETZp+ZvRQiB4Am4dHVvohFI0cMuWm4zuHkvxoEtX0Fx//bXm+9/fTXQm+KfTjwEgbPzwA1ZAAAIVCbjRHGlGIzo+Ch27yrDkEB079mTFkYd3m73cpNEZkoHD86PvFiNsfPcQ9kEAAoUJuLuttMy+Cp2pqauzJawuD/e0c2tS2N7NclPh6cuFNRFA2NQEkmYgAAH/CLi7rdzzhPTMqzYP99SdUDFv786LorFV27/nI1aLEDaxepZxQQACuQTycnT0Qq2hIzV19DTzOuvq2MtQseXWqJiRAox6fhPJwDyEXRBA2HRBnT4hAAFvCNhRnRMnFrOqyHZkRwyVF7R8JMIjy1ny7ypRHnsZ6ty5971hUMUQFYhSb0Z3qykr2a1G7kwVqtxTBwGETR0UaQMCEIiOgL64ZWDDBE8Z0WNHa+SlPz9/KAhmdt6SHoeRJ/xEzHSdvxQEUIxsnADCpnHEdAABCMREwD7kU6IVw172Knqk/L8sbZ09ezYTSPLxMWnYjsA899xxc+rUa7lu0+UljWB1mYgd07xiLPURQNjUx5KWIACBxAmUFT0S4egLhK2Vlraq4rYPJbWXkbS9q67aYNasWZMVQETAVKXMfV0RQNh0RZ5+IQCBZAi4tWvWrVuX5fLoMo8NQgSFCIt+xKd/2KNEfPp/Xv3J/+u/lx8GqblAes6SnL2lf88TMP0+prJ+br99K0tJyczIuAeKsInbv4wOAhDwgMBqtWvsKI+Y+rOf/av56KOPMjEzTPxUGZItYIjCVCHIPaEQQNiE4inshAAEgiWwcePnzIcfLpnJyUnz7ru/qzwOFUF2RMZuzD4Rux/h2TSIyFTulBshEBgBhE1gDsNcCEAgLAL2MtT69etNr/fbsAaAtRAIjADCJjCHYS4EIBAWATnFW7dH+7gbKiyaWAuB0QQQNqMZcQUEIACBSgTsaE3MRyhUgsNNEGiIAMKmIbA0CwEIQGB2dvfgeAGiNcwHCLRDAGHTDmd6gQAEEiNAtCYxhzNcbwggbLxxBYZAAAIxEbC3eM/PP2pmZnbGNDzGAgFvCSBsvHUNhkEAAqESIFoTquewOwYCCJsYvMgYIAABrwjY0Zq9ex8y+/bt8co+jIFAzAQQNjF7l7FBAAKdENiy5ebBUQbnzr3fiQ10CoFUCSBsUvU844YABBohYC9DEa1pBDGNQmBVAggbJggEIACBGgmQNFwjTJqCQAUCCJsK0LgFAhCAwDACugxFQT7mCAS6IYCw6YY7vUIAAhESYBkqQqcypOAIIGyCcxkGQwACvhKwl6FOn37VbN68yVdTsQsC0RJA2ETrWgYGAQi0TWBi4sqsS5ah2iZPfxC4SABhw2yAAAQgUAMBexmKSsM1AKUJCFQkgLCpCI7bIAABCNgEdBmKaA3zAgLdEkDYdMuf3iEAgQgIkDQcgRMZQjQEEDbRuJKBQAACXRGwk4apNNyVF+gXAn0CCBtmAgQgAIExCUjEZvv2u41UGuYU7zFhcjsExiSAsBkTILdDAAIQgAAEIOAPAYSNP77AEghAAAIQgAAExiSAsBkTILdDAAIQgAAEIOAPAYSNP77AEghAAAIQgAAExiSAsBkTILdDAAIQgAAEIOAPgf8HTYXt3c+/4TgAAAAASUVORK5CYII=",
            "submit": true,
            "alairas2": "data:image/png;base64,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"
          }
        }*/}
        this.refreshForm.emit({
          property: 'form',
          value: this.form
        });
        console.log(response)

      },
      error: (error) => {
        this.data.hideLoading()
        console.error('Error fetching data:', error);
      }
    })
  }

  private async getKapcsolodoSzulok() {
    if (this.loginmode !== "gondviselo" || !this.sajatIntezmeny?.intezmenyId) return []

    try {
      const gyerekek = Array.isArray(this.userMetadata?.gyermekek)
        ? this.userMetadata.gyermekek
        : []
      const gyerekAzonositoSet = new Set(
        gyerekek.map(g => `${g?.oktazon || ""}`).filter(Boolean)
      )

      if (gyerekAzonositoSet.size === 0) return []

      const szulok: any = await firstValueFrom(
        this.http.get('/api/nyilvantartas/szulo/' + this.sajatIntezmeny.intezmenyId)
      )

      if (!Array.isArray(szulok)) return []

      return szulok.filter((szulo: any) => {
        let kapcsolatok = szulo?.gyermekek
        if (typeof kapcsolatok === 'string') {
          try {
            kapcsolatok = JSON.parse(kapcsolatok)
          } catch {
            kapcsolatok = []
          }
        }
        if (!Array.isArray(kapcsolatok)) return false

        return kapcsolatok.some((k: any) => gyerekAzonositoSet.has(`${k?.oktazon || ""}`))
      })
    } catch (error) {
      console.error('Kapcsolodo szulok lekerese sikertelen:', error)
      return []
    }
  }

  private async getSajatGyerekek() {
    if (!this.sajatIntezmeny?.intezmenyId || !this.user$?.username) {
      return []
    }

    try {
      const gyerekek: any = await firstValueFrom(
        this.http.get(
          '/api/nyilvantartas/szulogyereke/' +
            this.user$.username +
            '/' +
            this.sajatIntezmeny.intezmenyId
        )
      )

      const forras = Array.isArray(gyerekek)
        ? gyerekek
        : Array.isArray(this.userMetadata?.gyermekek)
          ? this.userMetadata.gyermekek
          : []

      /*  SZÜLŐI FELÜGYELETI JOG (backend/felugyeleti-jog.js): a kiszolgáló a nem „teljes”
       *  felügyeletű kapcsolat gyermekét `felugyeleti_jog` jelöléssel adja – kérvényt rá csak a
       *  felügyeleti jogot gyakorló szülő adhat be, ezért a választóban nem kínáljuk. */
      return forras.filter((gyerek: any) => !gyerek?.felugyeleti_jog).map((gyerek: any) => {
        const nev = `${gyerek?.name || gyerek?.full_name || ""}`.trim()
        const oktazon = `${gyerek?.oktazon || ""}`.trim()
        const formKey = [nev, oktazon].filter(Boolean).join(' - ')

        return {
          ...gyerek,
          formKey
        }
      })
    } catch (error) {
      console.error('Sajat gyerekek lekerese sikertelen:', error)
      return []
    }
  }
  changeLanguage(language: string) {
    this.language = language;
    this.options.language = this.language;
    this.rebuildEmitter.next(this.options);
  }

  cancel(){

  }
  /** Határozat-sablonból készült beküldés? Ez nem önálló kérvény, nem kap saját sort. */
  hatarozatSor(row: any) {
    return row?.sablon_tipus === 'hatarozat';
  }

  /**
   *  A határozat szerkesztőjének megnyitása a kérvény adataival előtöltve.
   *  Csak akkor hívjuk, ha a kérvénysablonhoz VAN határozatsablon – enélkül a
   *  szerkesztő üres azonosítóval indulna és hibára futna.
   *
   *  A `hatarozatEredeti` beküldéskor kerül a kérésbe: ez köti a határozatot az
   *  eredeti kérvényhez, hogy annak a során „Határozat" gombként jelenjen meg,
   *  és ne külön sorként a listában.
   */
  private async hatarozatSzerkeszto(row: any, hatarozatId: string) {
    this.menu = 3;
    const teljes = await this.teljesKerveny(row);
    this.loadForm(hatarozatId, { ...(teljes?.data?.submission || { data: {} }), eredeti: row.id }, row.id);
  }

  /**
   *  A listák karcsúak (csak név, beküldő, gyermek, állapot – lásd backend karcsuKervenyek):
   *  a teljes beküldött adatot itt kérjük le, amikor tényleg kell.
   */
  private async teljesKerveny(row: any): Promise<any> {
    if (!row?.reszleges) return row;
    try {
      return await firstValueFrom(this.http.get('/api/forms/kerveny/' + row.id));
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A kérvény adatai nem tölthetők be.', 'error');
      return row;
    }
  }

  /** Ha határozatot töltünk ki, ennek a kérvénynek a határozata lesz. */
  hatarozatEredeti: string | null = null;

  /**
   *  ÚJRAGENERÁLÁS: melyik beküldött kérvény kap új PDF-et (null = rendes beküldés).
   *
   *  Ha a sablon szövegében utólag hibát találunk, a javítás eddig csak az ezutáni
   *  beküldésekre hatott – a korábbiak PDF-je a rossz szöveggel maradt, és a szülővel
   *  kellett volna újra kitöltetni. Itt a MEGLÉVŐ kitöltéssel nyitjuk meg a JAVÍTOTT
   *  sablont: a beírt adatok megmaradnak, csak a köréjük nyomtatott szöveg frissül.
   */
  ujrageneralando: any = null;

  /* ── Piszkozat: félbehagyott kitöltés ──────────────────────────────────── */

  /**
   *  Van olyan kérvény, amit MINDKÉT gondviselőnek alá kell írnia, a két szülő viszont
   *  nincs mindig egy helyen. Eddig az űrlapot egy ültő helyében végig kellett vinni.
   *  A piszkozat a kitöltés pillanatnyi állapota – a beírt mezőkkel ÉS a már megrajzolt
   *  aláírással együtt: az egyik szülő elmenti, a másik később befejezi és beküldi.
   */
  piszkozatok: any[] = [];

  /** Épp piszkozatból töltjük ki? (Beküldéskor ezt dobjuk el.) */
  piszkozatId: string | null = null;

  /** A formio legutóbbi állapota – ebből lesz a piszkozat, beküldés nélkül. */
  private aktualisKitoltes: any = null;

  /** A formio minden változásnál szól; csak eltesszük, nem csinálunk vele semmit. */
  onUrlapValtozas(event: any) {
    if (event?.data) this.aktualisKitoltes = event.data;
  }

  /** A kitöltésből a gyermek neve – ezen át látja a másik gondviselő a piszkozatot. */
  private piszkozatGyermeke(adat: any): string {
    for (const kulcs of Object.keys(adat || {})) {
      if (!/gyerm|tanul/i.test(kulcs)) continue;
      const ertek = adat[kulcs];
      if (typeof ertek === 'string' && ertek.trim()) return ertek.trim();
      if (ertek && typeof ertek === 'object' && !Array.isArray(ertek)) {
        const nev = ertek.name || ertek.full_name || ertek.label;
        if (nev) return String(nev).trim();
      }
    }
    return '';
  }

  /** A megkezdett kitöltés elmentése – beküldés nélkül. */
  async piszkozatMentes() {
    if (!this.form?.id) return;
    const adat = this.aktualisKitoltes || this.form?.submission?.data || {};
    await this.data.showLoading('Piszkozat mentése...');
    try {
      const valasz: any = await firstValueFrom(this.http.post('/api/forms/piszkozat', {
        id: this.piszkozatId,
        kervenyid: this.form.id,
        nev: this.form.name,
        gyermek: this.piszkozatGyermeke(adat),
        data: adat,
        user: this.user$?.username,
      }));
      this.piszkozatId = valasz?.id || this.piszkozatId;
      this.data.hideLoading();
      this.data.sendToast('Piszkozat elmentve. A „Kérvény kitöltés" fülön folytatható – '
        + 'a gyermek másik gondviselője is látja.', 'success');
      this.piszkozatokBetoltese();
    } catch (e: any) {
      this.data.hideLoading();
      console.error('A piszkozat mentése sikertelen:', e);
      this.data.sendToast(e?.error?.error || 'A piszkozat mentése nem sikerült.', 'error');
    }
  }

  /** A piszkozatok listája (sajátok + a közös gyerekre szólók a másik szülőtől). */
  piszkozatokBetoltese() {
    if (!this.user$?.username) return;
    this.http.get('/api/forms/piszkozatok/' + this.user$.username).subscribe({
      next: (valasz: any) => { this.piszkozatok = Array.isArray(valasz) ? valasz : []; },
      //  A piszkozat kiegészítés: ha nem jön le, a kérvény-képernyő menjen tovább.
      error: (hiba) => { this.piszkozatok = []; console.warn('Piszkozatok:', hiba); },
    });
  }

  /** Félbehagyott kitöltés folytatása – ugyanott, ahol abbamaradt. */
  piszkozatFolytatas(piszkozat: any) {
    this.piszkozatId = piszkozat?.id || null;
    this.aktualisKitoltes = piszkozat?.data || {};
    this.menu = 3;
    this.loadForm(piszkozat.kervenyid, { data: piszkozat?.data || {} });
  }

  /** Piszkozat eldobása. */
  async piszkozatTorles(piszkozat: any) {
    if (!confirm(`Biztosan eldobod ezt a félbehagyott kitöltést? (${piszkozat?.nev || 'kérvény'})`)) return;
    try {
      await firstValueFrom(this.http.delete('/api/forms/piszkozat/' + piszkozat.id
        + '?user=' + encodeURIComponent(this.user$?.username || '')));
      if (this.piszkozatId === piszkozat.id) this.piszkozatId = null;
      this.data.sendToast('A piszkozat eldobva.', 'success');
      this.piszkozatokBetoltese();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A piszkozat eldobása nem sikerült.', 'error');
    }
  }

  /** Újragenerálható-e ez a sor? (Visszavont kérvényt nem bolygatunk.) */
  ujrageneralhato(row: any): boolean {
    return !!row?.kervenyid && String(row?.status) !== '5';
  }

  /**
   *  A beküldött kérvény megnyitása a MAI sablonnal, a beküldő adataival előtöltve.
   *  Az ügyintéző átnézheti, javíthat is rajta, és az űrlap beküldésével készül az új,
   *  aláírt PDF – a régi a fájltárban marad, az útvonala a döntésnaplóba kerül.
   */
  async ujrageneralas(row: any) {
    if (!this.ujrageneralhato(row)) {
      this.data.sendToast('Ez a kérvény nem generálható újra.', 'warning');
      return;
    }
    this.ujrageneralando = row;
    this.menu = 3;
    const teljes = await this.teljesKerveny(row);
    this.loadForm(row.kervenyid, { ...(teljes?.data?.submission || { data: {} }) });
    this.data.sendToast('A kérvény a mai sablonnal, a beküldött adatokkal nyílt meg. '
      + 'Nézd át, majd küldd be – így készül az új PDF.', 'success');
  }

  /**
   *  MÁSOLAT A KIVÁLASZTOTT SABLONBÓL.
   *
   *  Új kérvény ritkán készül nulláról: rendszerint egy meglévőhöz hasonlít. Eddig vagy
   *  újra össze kellett rakni, vagy – rosszabb – a meglévőt írták át, amivel a már
   *  beküldött kérvények sablonja is megváltozott. A másolat önálló sablon, új
   *  azonosítóval, így a régi beküldések érintetlenek maradnak.
   */
  async masolatKeszit() {
    if (!this.selectedForm?.id) return;
    const eredetiNev = this.selectedForm.name;
    await this.data.showLoading('Másolat készítése...');
    try {
      const valasz: any = await firstValueFrom(
        this.http.post('/api/forms/masolat/' + this.selectedForm.id, {}));
      this.data.hideLoading();
      if (!valasz?.id) throw new Error('A kiszolgáló nem adott azonosítót.');
      this.data.sendToast(`Másolat készült: „${valasz.name}". A szerkesztő már ezt nyitotta meg.`, 'success');
      //  A friss listából választjuk ki a másolatot, hogy a szerkesztő azon dolgozzon –
      //  különben az eredetit szerkesztenénk tovább, észrevétlenül.
      await this.ngAfterViewInit();
      const masolat = (this.forms || []).find((f: any) => f.id === valasz.id);
      if (masolat) {
        this.selectedForm = masolat;
        this.loadEditor(true);
        this.menu = 2;
      }
    } catch (e: any) {
      this.data.hideLoading();
      console.error(`A(z) „${eredetiNev}" másolása sikertelen:`, e);
      this.data.sendToast(e?.error?.error || 'A másolat készítése nem sikerült.', 'error');
    }
  }

  initAtadas(row){
    this.atadasmodal.present()
  }


  /* ── Döntés a beküldött kérvényről ── */

  /** A döntés-modal állapota: melyik kérvényről, milyen döntés, milyen indoklással. */
  dontesSor: any = null;
  dontesTipus = 'elfogad';
  dontesIndoklas = '';

  /** A kérvényhez tartozó határozatsablon azonosítója (null = nincs ilyen). */
  dontesHatarozatSablon: string | null = null;
  dontesHatarozatGeneralas = false;

  /** A döntés-modal megnyitása egy konkrét beküldött kérvényre. */
  async dontesNyitas(row: any, tipus: string = 'elfogad') {
    this.dontesSor = row;
    // Már eldöntött kérvénynél a mostani döntés a kiindulás – így látszik, mit írunk felül.
    this.dontesTipus = tipus === 'elfogad'
      ? ({ '3': 'elutasit', '4': 'hianypotlas' }[String(row?.status)] || 'elfogad')
      : tipus;
    this.dontesIndoklas = '';
    this.dontesHatarozatSablon = null;
    this.dontesHatarozatGeneralas = false;
    this.dontesmodal.present();

    // A határozatsablon léte csak a kérvénysablonból derül ki, a lista sorai nem hozzák.
    try {
      const sablon: any = await firstValueFrom(this.http.get('/api/forms/get/' + row.kervenyid));
      this.dontesHatarozatSablon = sablon?.hatarozat || null;
      this.dontesHatarozatGeneralas = !!this.dontesHatarozatSablon;
    } catch {
      this.dontesHatarozatSablon = null;
    }
  }

  /**
   *  Döntés mentése. Az indoklás a beküldő oldalán is megjelenik (a `comment`
   *  mezőből), a teljes döntés-előzményt pedig a `dontesek` napló őrzi.
   */
  dontes(){
    if (!this.dontesSor?.id) { this.dontesmodal.dismiss(); return; }
    const indoklas = String(this.dontesIndoklas || '').trim();
    if (this.dontesTipus !== 'elfogad' && this.dontesTipus !== 'ujranyit' && !indoklas) {
      this.data.sendToast('Elutasításnál és hiánypótlásnál az indoklás kötelező.', 'warning');
      return;
    }

    this.http.post<any>('/api/forms/dontes/' + this.dontesSor.id, {
      dontes: this.dontesTipus,
      indoklas,
      ugyintezo: this.user$?.username || null,
    }).subscribe({
      next: (r) => {
        // A listákat helyben frissítjük, hogy ne kelljen újratölteni az oldalt.
        for (const lista of [this.sajatforms, this.allforms]) {
          const sor = (lista || []).find((x: any) => x.id === this.dontesSor.id);
          if (sor) { sor.status = String(r.status); sor.comment = indoklas; sor.dontesek = r.dontesek; }
        }
        this.applyKervenyFilters();
        this.dontesmodal.dismiss();
        this.data.sendToast('A döntés mentve.');

        // Elfogadásnál – ha van határozatsablon és a felhasználó kérte – rögtön
        // megnyitjuk a határozat szerkesztőjét a kérvény adataival.
        if (this.dontesTipus === 'elfogad' && this.dontesHatarozatGeneralas && this.dontesHatarozatSablon) {
          this.hatarozatSzerkeszto(this.dontesSor, this.dontesHatarozatSablon);
        }
      },
      error: (e) => this.data.sendToast(e?.error?.error || 'A döntés mentése nem sikerült.', 'error'),
    });
  }

  /**
   *  Kérvény visszavonása a beküldő által. NEM törlés: a kérvény és az aláírt PDF a
   *  helyén marad, csak lezárt („visszavont") státuszt kap – a beküldés ténye az
   *  iratkezelés szempontjából nem tüntethető el. Csak elbírálás előtt lehetséges.
   */
  async visszavonas(row: any) {
    if (!confirm('Biztosan visszavonod ezt a kérvényt? A beküldött kérvény megmarad, de lezárul.')) return;
    try {
      const r: any = await firstValueFrom(this.http.post(`/api/forms/visszavon/${row.id}`, {
        user: this.user$?.username,
      }));
      row.status = String(r?.status ?? '5');
      row.dontesek = r?.dontesek ?? row.dontesek;
      this.applyKervenyFilters();
      this.data.sendToast('A kérvényt visszavontuk.', 'success');
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A visszavonás nem sikerült.', 'error');
    }
  }

  /* ── Leadás-ellenőrzés: ki nem adta le még az adott kérvényt ── */

  leadasKerveny: string | null = null;
  leadasKor = '';                 // '' = a szerver dönti el (gyermekválasztós → tanulók)
  leadasKereses = '';
  leadasEredmeny: any = null;
  leadasFut = false;

  async leadasBetolt() {
    if (!this.leadasKerveny) { this.leadasEredmeny = null; return; }
    this.leadasFut = true;
    try {
      const kor = this.leadasKor ? '?kor=' + this.leadasKor : '';
      this.leadasEredmeny = await firstValueFrom(this.http.get<any>(
        `/api/forms/hianyzo/${this.leadasKerveny}/${this.sajatIntezmeny.intezmenyId}${kor}`));
    } catch (e: any) {
      this.leadasEredmeny = null;
      this.data.sendToast(e?.error?.error || 'A lekérdezés nem sikerült.', 'error');
    } finally { this.leadasFut = false; }
  }

  /** Névre/osztályra szűrt hiánylista (a keresőmező szerint). */
  leadasSzurt(lista: any[]): any[] {
    const k = String(this.leadasKereses || '').trim().toLowerCase();
    if (!k) return lista || [];
    return (lista || []).filter((r) =>
      `${r.nev || ''} ${r.csoport || ''} ${(r.szulok || []).map((sz: any) => sz.nev).join(' ')}`
        .toLowerCase().includes(k));
  }

  /** A hiányzók e-mail címei vágólapra – ebből mehet ki az emlékeztető. */
  leadasEmailMasol() {
    const lista = this.leadasSzurt(this.leadasEredmeny?.hianyzo || []);
    const cimek = new Set<string>();
    lista.forEach((r: any) => {
      if (r.email) cimek.add(String(r.email).trim());
      (r.szulok || []).forEach((sz: any) => { if (sz.email) cimek.add(String(sz.email).trim()); });
    });
    if (!cimek.size) { this.data.sendToast('Nincs e-mail cím a hiányzóknál.', 'warning'); return; }
    const szoveg = [...cimek].join('; ');
    navigator.clipboard?.writeText(szoveg)
      .then(() => this.data.sendToast(`${cimek.size} e-mail cím a vágólapon.`, 'success'))
      .catch(() => this.data.sendToast('A vágólapra másolás nem sikerült.', 'error'));
  }

  /** Státusz emberi neve (a döntés-modal fejlécéhez). */
  statuszNev(statusz: any): string {
    return {
      '1': 'ügyintézés szükséges',
      '2': 'elfogadva',
      '21': 'határozattal elfogadva',
      '3': 'elutasítva',
      '4': 'hiánypótlás szükséges',
      '5': 'visszavonva',
    }[String(statusz)] || 'ismeretlen';
  }

  /** A döntés indoklásának kiolvasása egy sorból (a napló utolsó eleme vagy a comment). */
  dontesIndoka(row: any): string {
    if (row?.comment) return String(row.comment);
    let naplo = row?.dontesek;
    if (typeof naplo === 'string') { try { naplo = JSON.parse(naplo); } catch { naplo = null; } }
    if (Array.isArray(naplo) && naplo.length) return String(naplo[naplo.length - 1]?.indoklas || '');
    return '';
  }
}
